// extracted by mini-css-extract-plugin
module.exports = {"h1":"Heading_h1__2rwnC","h2":"Heading_h2__24abv","h3":"Heading_h3__2klOu","h4":"Heading_h4__2mmYK"};